export default class UpdateEvent {
  constructor(name, fn, args) {
    this.name = name;
    this.fn   = fn;
    this.args = args;
  }
}


// WEBPACK FOOTER //
// ./src/Services/State/UpdateEvent.js